import styled from 'styled-components';

export const PricingRulesContainer = styled.div`
  margin-top: 30px;
  padding: 20px;
  background-color: #f5f5f5;
  border-radius: 4px;

  h5 {
    margin-top: 0;
    color: #333;
  }

  .grey-text {
    margin-bottom: 20px;
  }
`;

export const RuleItem = styled.div`
  margin-bottom: 20px;
  border-left: 4px solid #2196f3;

  .card-content {
    padding: 20px;

    .row {
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    small {
      display: block;
      margin-top: 10px;
    }
  }
`;

export const RemoveButton = styled.button`
  margin-top: 25px;
  background-color: #f44336 !important;

  &:hover {
    background-color: #d32f2f !important;
  }

  i {
    margin-right: 5px;
  }
`;
